import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-notification-modal',
  templateUrl: './notification-modal.component.html',
  styleUrls: ['./notification-modal.component.css']
})
export class NotificationModalComponent implements OnInit {

  @Input() modalNotifications;
  constructor() { }

  ngOnInit(): void {
  }

}
